import { AxiosResponse } from 'axios';
import api from './Api'

export const createAdminFcmTokenByToken = (params: IAdminFcmToken): Promise<AxiosResponse<IAdminFcmToken>> => {
    return api.post(`${process.env.REACT_APP_API_DOMAIN}/admin-fcm-token`, params);
}
